<template>
  <a-form :form="form" class="orderForm">
    <a-form-item
      v-bind="formItemLayout"
      v-for="(item,index) in orderParams"
      :key="index"
      :label="item.label"
      :class="item.key =='is_first_order'?'radio_item':''"
    >
      <div v-if="item.key == 'cloud_thumb'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="fileList"
          @preview="imgPreview"
          @change="imgChange"
          v-decorator="[item.key, { rules: [ {required: true, message: item.label}]}]"
        >
          <div v-if="item.value.length < 10">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">云资源下单成功截图，最多上传10张图片</div>
        <a-modal :visible="previewVisible" :footer="null" @cancel="imgCancel">
          <img alt="example" style="width: 100%" :src="previewImage">
        </a-modal>
      </div>
      <div v-else-if="item.key == 'is_first_order'">
        <a-radio-group
          v-decorator="[item.key,{initialValue:1},{ rules: [ {required: true, message: item.label}]}]"
        >
          <a-radio :value="1">是</a-radio>
          <a-radio :value="2">否</a-radio>
        </a-radio-group>
      </div>
      <div v-else-if="item.key == 'customer_manager_area'">
        <a-cascader
          class="orderInput"
          :options="options"
          :loadData="loadData"
          placeholder="请选择区域"
          :fieldNames="{ label: 'name', value: 'id', children: 'children'}"
          v-decorator="[item.key,{ rules: [ {required: 'areaCheck', message: item.label}],initialValue:item.value}]"
        />
      </div>
      <div v-else-if="item.key == 'client_company_name'">
        <a-input
          class="orderInput"
          v-decorator="[item.key,{ rules: [ {required: false}],initialValue:item.value}]"
        />
      </div>
      <div v-else-if="item.key == 'xcx_order_id'">
        <a-input
          class="orderInput"
          v-decorator="[item.key, { rules: [ {required: true, message: item.label}],initialValue:item.value}]"
          @change="getOrderTime"
        />
      </div>
      <div v-else>
        <a-input
          class="orderInput"
          :readOnly="item.key=='buy_time' || item.key=='buy_product'"
          v-decorator="[item.key, { rules: [ {required: true, message: item.label}],initialValue:item.value}]"
        />
      </div>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
      <a-button @click="submit" class="submit-btn" type="primary">提交订单</a-button>
    </a-form-item>
  </a-form>
</template>


<script>
import { throttle } from "../../utils/util.js";
const orderParams = [
  {
    label: "客户名称",
    key: "client_name",
    value: "张三"
  },
  {
    label: "公司名称",
    key: "client_company_name",
    value: "有限公司"
  },
  {
    label: "客户电话",
    key: "client_phone",
    value: "18688888888"
  },
  {
    label: "订单号码",
    key: "xcx_order_id",
    value: "123456789"
  },
  {
    label: "购买产品",
    key: "buy_product",
    value: "沃云"
  },
  {
    label: "购买时间",
    key: "buy_time",
    value: "2018-02-01 12:00:00"
  },
  {
    label: "小程序订单金额",
    key: "xcx_price",
    value: "100 "
  },
  {
    label: "云资源订单金额",
    key: "cloud_price",
    value: "100"
  },
  {
    label: "云资源下单截图",
    key: "cloud_thumb",
    value: [
      {
        uid: "-1",
        name: "xxx.png",
        status: "done",
        url:
          "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
      }
    ]
  },
  {
    label: "客户经理姓名",
    key: "customer_manager",
    value: "李四"
  },
  {
    label: "客户经理电话",
    key: "customer_manager_mobile",
    value: "13288888888"
  },
  {
    label: "客户经理地区",
    key: "customer_manager_area",
    value: ["1", "35", "380"]
  },
  {
    label: "客户经理部门",
    key: "department",
    value: "销售部"
  },
  {
    label: "首单",
    key: "is_first_order",
    value: 1
  },
  {
    label: "支撑经理姓名",
    key: "support_manager",
    value: "王五"
  },
  {
    label: "支撑经理电话",
    key: "support_manager_mobile",
    value: "18788888888"
  }
];
const formItemLayout = {
  labelCol: {
    xs: { span: 6 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 18 },
    sm: { span: 18 }
  }
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 6,
      offset: 6
    },
    sm: {
      span: 16,
      offset: 8
    }
  }
};
export default {
  data() {
    return {
      formItemLayout,
      tailFormItemLayout,
      orderParams,
      previewVisible: false,
      previewImage: "",
      fileList: [
        {
          uid: "-1",
          name: "xxx.png",
          status: "done",
          url:
            "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
        }
      ],
      options: [],
      area: [],
      hasSubmit: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.getArea();
  },
  munted() {},
  methods: {
    submit() {
      this.$message.warning("体验录单,无法提交");
    },
    //取消预览
    imgCancel() {
      this.previewVisible = false;
    },
    //图片预览
    imgPreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    beforeUpload(file) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      return flag;
    },
    //上传图片
    imgChange({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      this.fileList = fileList;
    },
    //三级联动
    areaChange(value) {
      this.area = value;
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      console.log(selectedOptions);
      let pid = targetOption.id;
      targetOption.loading = true;
      this.getArea(pid, res => {
        targetOption.loading = false;
        let list = res.data.data.reverse();
        let key = targetOption.key == "provice" ? "city" : "area";
        let isLeaf = targetOption.key == "area";
        let options = list.map((v, k) => {
          return Object.assign(v, {
            isLeaf: isLeaf,
            key: key
          });
        });
        targetOption.children = options || [];
        this.options = [...this.options];
      });
    },
    getArea(pid, callback) {
      let _this = this;
      axios({
        url: "/api/workOrder/getRegionList",
        method: "POST",
        data: {
          pid: pid || ""
        }
      }).then(res => {
        if (pid) {
          callback(res);
          return;
        }
        let list = res.data.data.reverse();
        let options = list.map((v, k) => {
          return Object.assign(v, {
            isLeaf: false,
            key: "province"
          });
        });
        Object.assign(options[0], {
          id: "1",
          pId: "0",
          name: "北京市",
          isLeaf: false,
          key: "province",
          loading: false,
          children: [
            {
              id: "35",
              pId: "1",
              name: "北京市",
              isLeaf: false,
              key: "area",
              loading: false,
              children: [
                {
                  id: "380",
                  pId: "35",
                  name: "东城区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "381",
                  pId: "35",
                  name: "西城区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "384",
                  pId: "35",
                  name: "朝阳区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "385",
                  pId: "35",
                  name: "丰台区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "386",
                  pId: "35",
                  name: "石景山区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "387",
                  pId: "35",
                  name: "海淀区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "388",
                  pId: "35",
                  name: "门头沟区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "389",
                  pId: "35",
                  name: "房山区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "390",
                  pId: "35",
                  name: "通州区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "391",
                  pId: "35",
                  name: "顺义区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "392",
                  pId: "35",
                  name: "昌平区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "393",
                  pId: "35",
                  name: "大兴区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "394",
                  pId: "35",
                  name: "怀柔区",
                  isLeaf: true,
                  key: "area"
                },
                {
                  id: "395",
                  pId: "35",
                  name: "平谷区",
                  isLeaf: true,
                  key: "area"
                }
              ]
            },
            { id: "3326", pId: "1", name: "县", isLeaf: false, key: "area" }
          ]
        });
        _this.options = options;
      });
    },
    //获取订单信息
    getOrderTime(e) {
      let _this = this;
      throttle(this, {
        callback() {
          axios({
            url: "/api/workOrder/order",
            method: "POST",
            data: {
              xcx_order_id: e.target.value
            }
          }).then(res => {
            let data = res.data.data;
            if (Array.isArray(data)) {
              _this.$message.error("请填写有效订单号");
              return;
            }
            _this.form.setFieldsValue({
              buy_product: data.name,
              buy_time: data.add_time
            });
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.orderForm {
  width: 675px;
}
.orderForm .orderInput ,.orderForm .orderInput >>>.ant-cascader-input{
  width: 330px;
  height: 40px;
  line-height: 40px;
  border-color: #dcdfe6;
}
.orderForm > .ant-form-item {
  margin-bottom: 20px;
}
.orderForm> .radio_item{
  margin-bottom: 0;
  position: relative;
  top: -10px;
}
.submit-btn {
  border-radius: 16px;
}
.uploadplus {
  font-size: 30px;
  color: #cfcdcd;
}
.uploadItem .ant-upload-select-picture-card {
  background: #f8f9fb;
}
.enter-tip {
  width: 100%;
  color: #9fa5bb;
  font-size: 14px;
  display: flex;
  height: 1em;
  line-height: 1em;
}
.uploadItem >>> .ant-upload-list {
  float: none;
}
.orderForm >>> .ant-form-item-required::before {
  content: "·";
  color: #ff7200;
  font-size: 18px;
}
.orderForm >>> .ant-form-item-required::after,.orderForm>>>.ant-form-item-label label::after {
  margin-right: 20px;
}
</style>
